import { render, staticRenderFns } from "./IconRightBottom2.vue?vue&type=template&id=130304aa&"
import script from "./IconRightBottom2.vue?vue&type=script&lang=js&"
export * from "./IconRightBottom2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130304aa')) {
      api.createRecord('130304aa', component.options)
    } else {
      api.reload('130304aa', component.options)
    }
    module.hot.accept("./IconRightBottom2.vue?vue&type=template&id=130304aa&", function () {
      api.rerender('130304aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconRightBottom2.vue"
export default component.exports